var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { DateParams, ExperimentMap, FilterParams } from "app/models/filter_form.model";
import { ActivatedRoute, Router } from "@angular/router";
import { FilterFormService } from "./filter_form.service";
import { TranslateService } from "app/translate/translate.service";
import merge from "lodash-es/merge";
import * as moment from 'moment-timezone';
import * as qs from 'qs';
import { setCookie, getCookie, limiter } from "app/lib/lib";
import dictionary from "dict/static.json";
import 'selectize/dist/css/selectize.css';
import 'selectize/dist/js/standalone/selectize.min.js';
import { AccessorService } from "../../support/accessor/accessor.service";
import { HelperService } from "../../lib/helper.service";
import { GroupRefService } from "../../support/group_ref/group_ref.service";
import { ReporQueriesModalComponent } from "./report_queries.component";
import { ModalService } from "../modal/base_modal.component";
var FilterFormComponent = /** @class */ (function () {
    function FilterFormComponent(router, route, filter, _translate, accessorService, helper, groupRef, modalService) {
        this.router = router;
        this.route = route;
        this.filter = filter;
        this._translate = _translate;
        this.accessorService = accessorService;
        this.helper = helper;
        this.groupRef = groupRef;
        this.modalService = modalService;
        this.isAccessorFilters = false;
        this.experimentMap = new ExperimentMap();
        this.moment = moment;
        this.prevDateType = '';
        this.selectize = {
            config: {
                valueField: 'mark',
                labelField: 'mark',
                searchField: 'mark',
                render: {
                    option: function (item) {
                        return '<div>' + item.mark.toUpperCase() + (item.isFlash ? '<span class="label label-info">flash</span>' : '') + '</div>';
                    }
                },
                load: null
            },
            options: null
        };
        this.selectizeSubject = {
            config: {
                valueField: 'subject',
                labelField: 'subject',
                searchField: 'subject'
            },
            options: []
        };
        this.selectizeTemplate = {
            config: {
                valueField: 'template',
                labelField: 'template',
                searchField: 'template'
            },
            options: []
        };
        this.selectizeWidget = {
            config: {
                maxItems: 4,
                valueField: 'name',
                labelField: 'caption',
                searchField: 'caption'
            },
            options: []
        };
        this.selectizeBadges = {
            config: {
                maxItems: 4,
                valueField: 'name',
                labelField: 'caption',
                searchField: 'caption'
            },
            options: []
        };
        this.paidStatusSelectize = {
            config: {
                maxItems: 4,
                valueField: 'name',
                labelField: 'caption',
                searchField: 'caption'
            },
            options: []
        };
        this.refGroups = [];
        this.refGroupList = [];
        this.refSourceList = [];
        // Настройки выпадающих списков фильтров по странам и городам
        this.selectizeLocation = {
            config: {
                valueField: 'ccode',
                labelField: 'caption',
                searchField: 'caption',
                maxItems: 4,
                closeAfterSelect: true
            },
            options: []
        };
        this.selectizeCity = {
            config: {
                valueField: 'name',
                labelField: 'caption',
                searchField: 'caption',
                maxItems: 4,
                closeAfterSelect: true
            },
            options: []
        };
        this.expandGroup = [
            'filter',
            'date',
            'user-type',
            'source',
            'processor-type',
            'siteFilter',
            'sites',
            'settings',
            'geo',
            'experiment'
        ];
        this.refererTypes = ['first', 'created', 'last', 'paid'];
        this.refExtendedFilterOperators = [
            'equal', 'contains', 'starts', 'ends',
            'regexp', 'empty', 'not equal', 'not contains', 'not start',
            'not end', 'not regexp', 'not empty'
        ];
        this.expandIds = [];
        this.baseUrl = this.router.url.split('?')[0];
        this.userPaidStatusList = [
            'inPaidMode', 'isOrWasPaidMode', 'isPaid', 'isNotPaid', 'isFree', 'isPaidExpired', 'uncompBacket',
            'isDidNotPaid'
        ];
        var me = this;
        me.dictionary = dictionary;
        me.selectize.config.load = limiter(function (value, cb) {
            me.filter.getPromocodeList({ promocodeMark: value }).subscribe(function (_a) {
                var stats = _a.stats;
                return cb(stats);
            });
        });
        me.filter.getPromocodeList({}).subscribe(function (_a) {
            var stats = _a.stats;
            me.selectize.options = stats;
        });
        me.subjectList.forEach(function (subject, i) {
            me.selectizeSubject.options.push({ _id: i, subject: subject });
        });
        me.templateList.forEach(function (template, i) {
            me.selectizeTemplate.options.push({ _id: i, template: template });
        });
        me.selectizeLocation.options = me.locations.slice();
        me.selectizeCity.config['load'] = me.helper.delimit(function (query, cb) {
            me.filter
                .getCityList(me.filter.filterParams.countries[0], query)
                .subscribe(cb);
        });
        me.selectizeWidget.options = dictionary.widgetList.slice().map(function (w) { return ({
            caption: me._translate.__("widgets." + w + ".name"),
            name: w
        }); });
        me.selectizeBadges.options = dictionary.badgeList.slice().map(function (b) { return ({
            caption: me._translate.__("bages." + b + ".name"),
            name: b
        }); });
        me.paidStatusSelectize.options = ['trial', 'trialExpired', 'paid', 'paidExpired'].map(function (value) {
            return {
                caption: me._translate.__('adminstat.filterForm.paidStatusList.' + value),
                name: value
            };
        });
    }
    Object.defineProperty(FilterFormComponent.prototype, "locations", {
        get: function () { return this.dictionary.locations; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "socialFilter", {
        get: function () { return this.dictionary.socialFilter; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "serverAliasList", {
        get: function () { return this.dictionary.serverAliasList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "serverZoneList", {
        get: function () { return this.dictionary.serverZoneList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "subjectList", {
        get: function () { return this.dictionary.subjectList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "templateList", {
        get: function () { return this.dictionary.templateList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "processorList", {
        get: function () { return this.dictionary.processorList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "currencyList", {
        get: function () { return this.dictionary.currencyList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "tariffVariantList", {
        get: function () { return this.dictionary.tariffVariantList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "tariffIdList", {
        get: function () { return this.dictionary.tariffIdList; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "siteCategories", {
        get: function () { return Object.keys(this.dictionary.siteCategories); },
        enumerable: true,
        configurable: true
    });
    FilterFormComponent.prototype.getSubjectsByCategory = function (category) {
        return category && this.dictionary.siteCategories[category] ? Object.keys(this.dictionary.siteCategories[category]) : [];
    };
    Object.defineProperty(FilterFormComponent.prototype, "emailList", {
        get: function () { return Object.keys(this.dictionary.emailList); },
        enumerable: true,
        configurable: true
    });
    FilterFormComponent.prototype.getEmailListWithGroups = function () {
        return [
            ''
        ].concat(Object.keys(this.dictionary.emailList), [
            'other',
        ]);
    };
    Object.defineProperty(FilterFormComponent.prototype, "localesMap", {
        get: function () {
            var me = this;
            return Object.keys(this.dictionary.localesMap).reduce(function (obj, key) {
                obj[key] = me.dictionary.localesMap[key];
                return obj;
            }, {
                'all': this._translate.instant('adminstat.common.any'),
                'not_ru': 'not_ru'
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterFormComponent.prototype, "createdDevices", {
        get: function () {
            return {
                'all': this._translate.instant('adminstat.common.any'),
                'mobile': 'Mobile',
                'tablet': 'Tablet',
                'desktop': 'Desktop',
            };
        },
        enumerable: true,
        configurable: true
    });
    FilterFormComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a, _b, refGroup, group, refSourceList, expandMap;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        me = this;
                        _a = me;
                        return [4 /*yield*/, me.filter.groupRef.getGroups().toPromise()];
                    case 1:
                        _a.refGroups = _c.sent();
                        _b = me;
                        return [4 /*yield*/, me.filter.getRefGroupFilterList()];
                    case 2:
                        _b.refGroupList = _c.sent();
                        refGroup = me.filter.filterParams.refGroup;
                        if (!(refGroup && refGroup !== 'all' && refGroup !== 'Direct')) return [3 /*break*/, 4];
                        group = me.refGroups.find(function (g) { return g.name === refGroup; });
                        return [4 /*yield*/, me.groupRef.getSources(group.id).toPromise()];
                    case 3:
                        refSourceList = _c.sent();
                        me.refSourceList = refSourceList.map(function (s) { return s.name; });
                        _c.label = 4;
                    case 4:
                        this.filter.addFilterParams = this.addFilterParams;
                        expandMap = this.expandGroup.reduce(function (expandGroup, key) {
                            expandGroup[key] = getCookie(key);
                            return expandGroup;
                        }, {});
                        me.expandIds = [];
                        Object.keys(expandMap).forEach(function (group) {
                            if (expandMap[group] == 'true') {
                                me.expandIds.push(group);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    // Применить фильтры
    FilterFormComponent.prototype.applyFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, params, url, paramsAsStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.filter.filterParams.page = 1;
                        if (me.filter.filterParams.experimentName !== '') {
                            me.filter.filterParams[me.filter.filterParams.experimentName] = me.filter.filterParams.experimentValue;
                        }
                        params = me.filter.getApplyFilters(me.filter.filterParams), url = me.router.url.split('?')[0];
                        me.filter.renderFilterTags(params);
                        paramsAsStr = qs.stringify(params, { encode: false });
                        me.filter.setReportGUID();
                        if (!me.isAccessorFilters) return [3 /*break*/, 2];
                        return [4 /*yield*/, me.accessorService.saveConfig(params).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        me.router.navigateByUrl(url + "?" + paramsAsStr, { relativeTo: me.route });
                        return [2 /*return*/];
                }
            });
        });
    };
    // Сбросить фильтры
    FilterFormComponent.prototype.resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filter.filterParams = new FilterParams();
                        this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
                        this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                        params = merge({}, this.filter.getDiffParams(this.filter.filterParams)), url = this.router.url.split('?')[0];
                        delete params.dateFilters;
                        delete params.isRegDay;
                        delete params.isBilling;
                        delete params.isDomainBilling;
                        delete params.isExpiredDomains;
                        delete params.isNotice;
                        delete params.dateFilterParams;
                        delete params.userType;
                        delete params.dateType;
                        if (!this.isAccessorFilters) return [3 /*break*/, 2];
                        // Если это режим фильтров для Панели асессоров, то не нужно никаких тегов при нажатии на кнопку "Сбросить фильтры"
                        this.filter.renderFilterTags({});
                        // Если это режим фильтров для Панели асессоров, то сохранить конфиг в mysql
                        this.filter.filterParams = new FilterParams();
                        this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                        return [4 /*yield*/, this.accessorService.saveConfig(qs.stringify(params, { encode: false })).toPromise()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.filter.renderFilterTags(this.filter.addFilterParams);
                        this.router.navigate([url], { relativeTo: this.route, queryParams: params });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Смена типа фильтра по реферерам (Простой, Расширенный)
    FilterFormComponent.prototype.changeRefererType = function (type) {
        if (type == this.filter.filterParams.refererFilterType)
            return true;
        this.filter.filterParams.refererFilterType = type;
        if (type == 'extended') {
            this.filter.filterParams.refGroup = 'all';
            this.filter.filterParams.refSource = 'all';
            this.filter.filterParams.refExtendedFilters.push({
                refererType: this.filter.filterParams.refererType || 'first',
                searchByMarkUtm: 'utm_source',
                searchByMarkRule: 'equal',
                refererSearchValue: ''
            });
        }
        else if (type == 'simple') {
            this.filter.filterParams.refExtendedFilters = [];
        }
    };
    // Расширенный фильтр по реферерам - Удалить правило
    FilterFormComponent.prototype.refMinus = function () {
        if (this.filter.filterParams.refExtendedFilters.length <= 1) {
            return true;
        }
        this.filter.filterParams.refExtendedFilters.splice(this.filter.filterParams.refExtendedFilters.length - 2, 2);
    };
    // Расширенный фильтр по реферерам - Добавить правило
    FilterFormComponent.prototype.refPlus = function (cond) {
        this.filter.filterParams.refExtendedFilters.push({
            condition: cond
        });
        this.filter.filterParams.refExtendedFilters.push({
            refererType: 'first',
            searchByMarkUtm: 'utm_source',
            searchByMarkRule: 'equal',
            refererSearchValue: ''
        });
    };
    FilterFormComponent.prototype.onAccordionClick = function ($event) {
        setCookie($event.panelId, $event.nextState);
    };
    FilterFormComponent.prototype.onUserPaidTypeChange = function (userPaidType) {
        var me = this;
        if (userPaidType === 'uncompBacket') {
            if (!me.filter.filterParams.dateFilterParams['uncompBacketTime']) {
                me.prevDateType = me.filter.filterParams.dateType;
                me.filter.filterParams.dateType = 'uncompBacketTime';
                me.filter.filterParams.dateFilterParams['uncompBacketTime'] = new DateParams();
                me.filter.filterParams.dateFilterParams['uncompBacketTime'].type = 'other';
            }
        }
        else if (me.filter.filterParams.dateFilterParams['uncompBacketTime']) {
            me.filter.filterParams.dateType = me.prevDateType;
            delete me.filter.filterParams.dateFilterParams['uncompBacketTime'];
        }
    };
    FilterFormComponent.prototype.onRefGroupSelect = function (refGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.filter.getRefSourceFilterList(refGroup)];
                    case 1:
                        _a.refSourceList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterFormComponent.prototype.onPaidStatusChange = function () {
        var me = this, paidStatus = me.filter.filterParams.paidStatus;
        if (paidStatus !== 'trial') {
            delete me.filter.filterParams.trialStart;
            delete me.filter.filterParams.trialEnd;
        }
    };
    FilterFormComponent.prototype.showReporQueries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal, queries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modal = this.modalService.openEmpty(ReporQueriesModalComponent, { size: '1000px' });
                        return [4 /*yield*/, this.filter.getReportQueries().toPromise()];
                    case 1:
                        queries = (_a.sent()).queries;
                        this.modalService.fillData(modal, { title: 'SQL запросы', queries: queries }).result.then(function () { });
                        return [2 /*return*/];
                }
            });
        });
    };
    return FilterFormComponent;
}());
export { FilterFormComponent };
